import about1Small from '@/assets/media/about/about-1-480.webp';
import about1Large from '@/assets/media/about/about-1-1200.webp';
import about2Small from '@/assets/media/about/about-2-480.webp';
import about2Large from '@/assets/media/about/about-2-1200.webp';
import about3Small from '@/assets/media/about/about-3-480.webp';
import about3Large from '@/assets/media/about/about-3-1200.webp';
import about4Small from '@/assets/media/about/about-4-480.webp';
import about4Large from '@/assets/media/about/about-4-1200.webp';
import about5Small from '@/assets/media/about/about-5-480.webp';
import about5Large from '@/assets/media/about/about-5-1200.webp';
import about6Small from '@/assets/media/about/about-6-480.webp';
import about6Large from '@/assets/media/about/about-6-1200.webp';
import about7Small from '@/assets/media/about/about-7-480.webp';
import about7Large from '@/assets/media/about/about-7-1200.webp';
import hero1Small from '@/assets/media/hero/hero-1-480.webp';
import hero1Large from '@/assets/media/hero/hero-1-1200.webp';
import hero2Small from '@/assets/media/hero/hero-2-480.webp';
import hero2Large from '@/assets/media/hero/hero-2-1200.webp';
import hero3Small from '@/assets/media/hero/hero-3-480.webp';
import hero3Large from '@/assets/media/hero/hero-3-1200.webp';
import hero4Small from '@/assets/media/hero/hero-4-480.webp';
import hero4Large from '@/assets/media/hero/hero-4-1200.webp';
import hero5Small from '@/assets/media/hero/hero-5-480.webp';
import hero5Large from '@/assets/media/hero/hero-5-1200.webp';

const responsiveImage = (id, small, large, largeWidth = 1200) => ({
  id,
  src: small,
  srcSet: `${small} 480w, ${large} ${largeWidth}w`,
  full: large,
});

const about1 = responsiveImage('about-1', about1Small, about1Large, 796);
const about2 = responsiveImage('about-2', about2Small, about2Large, 576);
const about3 = responsiveImage('about-3', about3Small, about3Large, 768);
const about4 = responsiveImage('about-4', about4Small, about4Large, 576);
const about5 = responsiveImage('about-5', about5Small, about5Large);
const about6 = responsiveImage('about-6', about6Small, about6Large);
const about7 = responsiveImage('about-7', about7Small, about7Large, 1024);
const hero1 = responsiveImage('hero-1', hero1Small, hero1Large);
const hero2 = responsiveImage('hero-2', hero2Small, hero2Large);
const hero3 = responsiveImage('hero-3', hero3Small, hero3Large);
const hero4 = responsiveImage('hero-4', hero4Small, hero4Large);
const hero5 = responsiveImage('hero-5', hero5Small, hero5Large);

export const heroImages = [hero1, hero2, hero3, hero4, hero5];

export const galleryImages = [
  about1,
  about2,
  about3,
  about4,
  about5,
  about6,
  about7,
  ...heroImages,
];

export const aboutImages = [
  about1,
  about2,
  about3,
  about4,
  about5,
  about6,
  about7,
  hero1,
  hero4,
  hero5,
];
